/**
 * Frases do núcleo (`localStorage.core`) liberadas para /dashboard-vendas e papel Painel de Metas.
 * Comparação com `normalizeCoreName` (sem acento, minúsculo, espaços normalizados).
 */
const DASHBOARD_VENDAS_ALLOWED_CORE_PHRASES = [
  'nuc ribeirao preto',
  'nuc bauru dom',
  'nuc curitiba dom',
  'nuc londrina dom',
  'nuc pe dom',
  'nuc porto alegre dom',
  'nuc salvador dom',
  'nuc se dom',
  'nuc sul ba dom',
];

/**
 * @param {string | null | undefined} raw
 * @returns {string}
 */
export function normalizeCoreName(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

export function isDashboardVendasCoreAllowed() {
  const fromStorage = normalizeCoreName(localStorage.getItem('core'));
  if (!fromStorage) return false;
  const allowedNormalized = DASHBOARD_VENDAS_ALLOWED_CORE_PHRASES.map(p =>
    normalizeCoreName(p),
  );
  return allowedNormalized.includes(fromStorage);
}
